import { useParams } from 'react-router-dom';
import { useGetReleaseSchemaQuery } from '../../rtk/api/datagroupsApi';
import { formatApiError } from '../../utils/release/apiError';
import Banner from '../../components/Common/Banner';
import styles from './SchemaDisplayPage.module.css';

export default function SchemaDisplayPage() {
  const { version } = useParams();
  const releaseVersion = version?.replace('.schema.json', '');

  const {
    data: schema,
    error,
    isLoading: loading,
  } = useGetReleaseSchemaQuery({ groupName: 'Lab', releaseVersion }, { skip: !releaseVersion });

  if (loading) return <div>Loading schema...</div>;

  return (
    <div style={{ padding: '1rem' }}>
      <h2>{`Release schema bundle : v${version}`}</h2>
      {error ? (
        // A deprecated release's schema is removed from S3, so the fetch fails.
        // Show the reason instead of an empty <pre>.
        <Banner variant="error">
          {formatApiError(
            error,
            `Schema for release ${releaseVersion} is not available. It may have been deprecated.`
          )}
        </Banner>
      ) : (
        <div className={styles.schema_display_container}>
          <pre style={{ whiteSpace: 'pre-wrap', marginTop: '1rem' }}>
            {JSON.stringify(schema, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}
